import { render } from "./registerForm.vue?vue&type=template&id=52529ca4&scoped=true"
import script from "./registerForm.vue?vue&type=script&lang=js"
export * from "./registerForm.vue?vue&type=script&lang=js"

import "./registerForm.vue?vue&type=style&index=0&id=52529ca4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52529ca4"]])

export default __exports__